import * as Immutable from 'immutable';
import LayerStore from '../../Layer/_stores/LayerStore';

export interface ILayerListStore {
	layers: Immutable.OrderedMap<string, LayerStore>
	layersOrder: Immutable.OrderedSet<string>
	selectedLayerId: string
	opened: boolean
}

const defaultStore = Immutable.Record<ILayerListStore>({
	layers: Immutable.OrderedMap<string, LayerStore>(),
	layersOrder: Immutable.OrderedSet<string>(),
	selectedLayerId: undefined,
	opened: false
});

export default class LayerListStore extends defaultStore implements ILayerListStore {}